import type { CanvasComponent, RestAction, Variable } from '../../types/project';

export type RequestInputSource = { id: string; label: string; template: string };
export type RequestInputTarget =
  | { location: 'url' }
  | { location: 'bodyTemplate' }
  | { location: 'headers'; key: string }
  | { location: 'queryParameters'; key: string };

export function requestInputSources(
  components: CanvasComponent[],
  variables: Record<string, Variable>,
): RequestInputSource[] {
  const componentNameCounts = components.reduce<Record<string, number>>((counts, component) => {
    counts[component.name] = (counts[component.name] ?? 0) + 1;
    return counts;
  }, {});
  return [
    ...components.filter((component) => componentNameCounts[component.name] === 1).map((component) => ({
      id: `component:${component.id}`,
      label: `Component: ${component.name}`,
      template: `{{components.${component.name}.value}}`,
    })),
    ...Object.keys(variables).map((name) => ({
      id: `variable:${name}`,
      label: `Variable: ${name}`,
      template: `{{variables.${name}}}`,
    })),
  ];
}

export function insertRequestInput(action: RestAction, target: RequestInputTarget, template: string): RestAction {
  if (target.location === 'url') return { ...action, url: `${action.url}${template}` };
  if (target.location === 'bodyTemplate') {
    return { ...action, bodyTemplate: `${action.bodyTemplate ?? ''}${template}` };
  }
  return {
    ...action,
    [target.location]: {
      ...(action[target.location] ?? {}),
      [target.key]: template,
    },
  };
}

export function hasOpenTemplate(value: string): boolean {
  return value.lastIndexOf('{{') > value.lastIndexOf('}}');
}

export function applyTemplateSuggestion(value: string, template: string): string {
  const templateStart = value.lastIndexOf('{{');
  return templateStart >= 0
    ? `${value.slice(0, templateStart)}${template}`
    : `${value}${template}`;
}
